'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _heuristicGlobalToLocal = require('./heuristicGlobalToLocal');

var _heuristicGlobalToLocal2 = _interopRequireDefault(_heuristicGlobalToLocal);

var _getGlobalBoundingClientRect = require('./getGlobalBoundingClientRect');

var _getGlobalBoundingClientRect2 = _interopRequireDefault(_getGlobalBoundingClientRect);

var _lodashCollectionFindWhere = require('lodash/collection/findWhere');

var _lodashCollectionFindWhere2 = _interopRequireDefault(_lodashCollectionFindWhere);

var _lodashObjectMapKeys = require('lodash/object/mapKeys');

var _lodashObjectMapKeys2 = _interopRequireDefault(_lodashObjectMapKeys);

var _lodashStringCamelCase = require('lodash/string/camelCase');

var _lodashStringCamelCase2 = _interopRequireDefault(_lodashStringCamelCase);

var TRANSFORM_PROPS = ['transform', 'transform-origin', 'prespective', 'prespective-origin', 'transform-style'];
var NULL_VALUES = ['none', 'matrix(1, 0, 0, 1, 0, 0)'];
var NULL_TRANSFORM = 'matrix(1, 0, 0, 1, 0, 0)'; //none dosen't alwasy trigger a refresh in Chrome

var CSSCoordinator = (function () {
  function CSSCoordinator() {
    _classCallCheck(this, CSSCoordinator);

    this._buffMockDiv = [];
    this._picker = _react2['default'].createElement('div', { key: 'picker' });

    this._mockMount = document.createElement('div');
    this._mockMount.style.pointerEvents = 'none';
    this._mockMount.style.opacity = 0;
    this._mockMount.style.position = 'absolute';
    this._mockMount.style.top = '0px';
    this._mockMount.style.left = '0px';
    this._mockMount.setAttribute('transhand-dom-tree-mock', 1); //just for debug
    document.body.appendChild(this._mockMount);
  }

  _createClass(CSSCoordinator, [{
    key: 'destroy',
    value: function destroy() {
      if (this._mockMount.parentNode) {
        this._mockMount.parentNode.removeChild(this._mockMount);
      }
    }
  }, {
    key: 'localToGlobal',
    value: function localToGlobal(p) {

      if (this._hasTransform) {
        var dePicker = this._dePicker;
        if (!dePicker) return p;

        dePicker.style.left = p.x + 'px';
        dePicker.style.top = p.y + 'px';

        var br = dePicker.getBoundingClientRect();

        return {
          x: br.left,
          y: br.top
        };
      } else {
        return p;
      }
    }
  }, {
    key: 'globalToLocal',
    value: function globalToLocal(p) {

      if (this._hasTransform) {
        var dePicker = this._dePicker;
        if (!dePicker) return p;

        var ret = (0, _heuristicGlobalToLocal2['default'])(p, dePicker);

        return ret;
      } else {
        return p;
      }
    }
  }, {
    key: 'setLocalRoot',
    value: function setLocalRoot(deParent, deTarget, onDone) {
      var _this = this;

      var done = function done() {
        _this.isProcessing = false;

        if (_this.onProcessingDone) {
          _this.onProcessingDone(_this._rect);
          _this.onProcessingDone = undefined;
        }
      };

      var walkBack = function walkBack(de) {

        if (!de || de === window.document.body) return;

        if (de.nodeName === '#document') {

          var iframes = de.defaultView.parent.document.querySelectorAll('iframe');
          var iframe = (0, _lodashCollectionFindWhere2['default'])(iframes, { contentDocument: de });

          if (iframe) {
            walkBack(iframe);
            return;
          } else {
            return;
          }
        }

        var reg;
        var computedStyle = window.getComputedStyle(de);

        TRANSFORM_PROPS.forEach(function (propName) {

          var value = computedStyle.getPropertyValue(propName);
          if (value && NULL_VALUES.indexOf(value) === -1) {
            set(propName, value);
          }
        });

        walkBack(de.parentNode);

        function set(propName, value) {

          if (!reg) {
            reg = {
              de: de,
              inlineTransform: de.style.transform,
              style: {}
            };

            transformeds.unshift(reg);
          }

          de.style.transform = NULL_TRANSFORM;
          reg.style[propName] = value;
        }
      };

      var setRect = function setRect() {
        var inlineTransform = deTarget.style.transform;
        deTarget.style.transform = NULL_TRANSFORM;

        var brA = (0, _getGlobalBoundingClientRect2['default'])(deTarget);

        if (_this._hasTransform) {
          var brB = (0, _getGlobalBoundingClientRect2['default'])(deParent);

          _this._rect = {
            x: brA.left - brB.left,
            y: brA.top - brB.top,
            w: brA.width,
            h: brA.height
          };
        } else {
          _this._rect = {
            x: brA.left,
            y: brA.top,
            w: brA.width,
            h: brA.height
          };
        }

        deTarget.style.transform = inlineTransform;
      };

      ////////////////////////////////////////////////////////////////////////////

      var transformeds = [];

      this.isProcessing = true;
      this.onProcessingDone = onDone;

      walkBack(deParent);

      this._hasTransform = transformeds.length !== 0;

      setRect();

      if (this._hasTransform) {
        transformeds.forEach(function (reg) {
          reg.br = (0, _getGlobalBoundingClientRect2['default'])(reg.de);
        });

        var brParent = (0, _getGlobalBoundingClientRect2['default'])(deParent);
        var brLastTransformed = transformeds[transformeds.length - 1].br;

        var parentOffsetFromLastTransformed = {
          x: brParent.left - brLastTransformed.left,
          y: brParent.top - brLastTransformed.top
        };

        _reactDom2['default'].render(_react2['default'].createElement(
          MockDiv,
          {
            parentOffsetFromLastTransformed: parentOffsetFromLastTransformed,
            parentLeft: -window.scrollX,
            parentTop: -window.scrollY,
            transformList: transformeds },
          _react2['default'].createElement('div', { id: 'picker', style: { position: 'absolute' } })
        ), this._mockMount, function () {

          _this._dePicker = _this._mockMount.querySelector('#picker');
          done();
        });
      } else {
        done();
      }

      transformeds.forEach(function (reg) {
        reg.de.style.transform = reg.inlineTransform;
      });
    }
  }]);

  return CSSCoordinator;
})();

exports['default'] = CSSCoordinator;

var MockDiv = (function (_React$Component) {
  _inherits(MockDiv, _React$Component);

  function MockDiv() {
    _classCallCheck(this, MockDiv);

    _get(Object.getPrototypeOf(MockDiv.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(MockDiv, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var transformList = _props.transformList;
      var transformListIdx = _props.transformListIdx;
      var parentLeft = _props.parentLeft;
      var parentTop = _props.parentTop;
      var parentOffsetFromLastTransformed = _props.parentOffsetFromLastTransformed;
      var transformReg = transformList[transformListIdx];
      var br = transformReg.br;

      var renderChild = function renderChild() {
        if (transformListIdx < transformList.length - 1) {
          return _react2['default'].createElement(
            MockDiv,
            {
              picker: _this2.props.picker,
              parentLeft: br.left,
              parentTop: br.top,
              parentOffsetFromLastTransformed: parentOffsetFromLastTransformed,
              transformList: transformList,
              transformListIdx: transformListIdx + 1 },
            _this2.props.children
          );
        } else {
          var x = parentOffsetFromLastTransformed.x;
          var y = parentOffsetFromLastTransformed.y;

          return _react2['default'].createElement(
            'div',
            { style: {
                position: 'absolute',
                left: x,
                top: y
              } },
            _this2.props.children
          );
        }
      };

      return _react2['default'].createElement(
        'div',
        { style: _extends({
            position: 'absolute',
            left: br.left - parentLeft,
            top: br.top - parentTop,
            width: br.width,
            height: br.height
          }, (0, _lodashObjectMapKeys2['default'])(transformReg.style, function (value, key) {
            return (0, _lodashStringCamelCase2['default'])(key);
          })) },
        renderChild()
      );
    }
  }], [{
    key: 'defaultProps',
    value: {
      transformListIdx: 0,
      parentLeft: 0,
      parentTop: 0
    },
    enumerable: true
  }]);

  return MockDiv;
})(_react2['default'].Component);

module.exports = exports['default'];
//# sourceMappingURL=CSSCoordinator.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/CSSCoordinator.js
 ** module id = 557
 ** module chunks = 0
 **/